<div class="layout-settings settings-container">
  <div class="section">
    <label class="label">Layout</label>
    <div class="templates-grid">
      <!-- <div class="settings-action-btn" (click)="openLayoutModal()">
        <div
          *ngFor="let cell of cells"
          class="cell-preview"
          [class.cell-text]="cell.type === 'text'"
          [class.cell-image]="cell.type === 'image'"
          [class.cell-video]="cell.type === 'video'"
          [class.cell-has-bg]="cell.bg"
          [style.left.%]="cell.x * 100"
          [style.top.%]="cell.y * 100"
          [style.width.%]="cell.w * 100"
          [style.height.%]="cell.h * 100"
        >
          <div
            *ngIf="cell.bg"
            class="cell-bg"
            [style.background-color]="
              cell.bg.type === 'color' ? cell.bg.color : 'transparent'
            "
          ></div>
          <div
            class="cell-content"
            [style.aspect-ratio]="cell.aspectRatio"
          ></div>
        </div>
      </div> -->

      <button class="settings-action-btn" (click)="openLayoutModal('layout')">
        <nw-icon type="view_cozy" [outlined]="true" color="black"></nw-icon>
      </button>
      <!-- </div> -->
      <div class="settings-action-btn" (click)="regenerateLayout()">
        <nw-icon type="refresh" color="black"></nw-icon>
      </div>
    </div>
  </div>

  <div class="section">
    <div class="label">Animation</div>
    <div class="templates-grid">
      <div class="settings-action-btn" (click)="openLayoutModal('animation')">
        <nw-icon type="view_cozy" [outlined]="true" color="black"></nw-icon>
      </div>
      <div class="settings-action-btn" (click)="regenerateAnimation()">
        <nw-icon type="refresh" color="black"></nw-icon>
      </div>
    </div>
  </div>

  <div class="section">
    <div class="label">Background</div>
    <div class="templates-grid">
      <div class="settings-action-btn" (click)="openLayoutModal('background')">
        <nw-icon type="view_cozy" [outlined]="true" color="black"></nw-icon>
      </div>
      <div class="settings-action-btn" (click)="regenerateBackground()">
        <nw-icon type="refresh" color="black"></nw-icon>
      </div>
    </div>
  </div>

  <!-- Layout Modal -->
  <nw-previews-modal
    *ngIf="previewMode"
    [previewMode]="previewMode"
    (close)="closeModal()"
  ></nw-previews-modal>
</div>
